import React, {memo, Fragment} from 'react'
import {connect} from 'react-redux'

/* Components */
import FooterTop from './components/FooterTop'
import FooterBottom from './components/FooterBottom'
import FooterRow from '../shared/FooterRow'

/* Styles */
import './desktop-footer.scss'

const DynamicFooter = memo(({columns, isMobileApp}) => {

  if (!columns?.length || isMobileApp) {
    return null
  }

  return (
    <Fragment>
      <div className='footer-top' />
      <footer className='footer'>
        <FooterTop />
        <div className='footer__middle'>
          <div className='footer__container'>
            <div className='footer__row'>
              {columns?.map((column) => (
                <div className='footer__column'>
                  {column?.sections?.map((section) => (
                    <Fragment>
                      <h4 className='footer__title'>{section?.title}</h4>
                      <ul className='footer__list'>
                        {section?.rows?.map((row) => <FooterRow row={row} />)}
                      </ul>
                    </Fragment>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        <FooterBottom />
      </footer>
    </Fragment>
  )
})

const mapStateToProps = (state) => {
  const {
    footerState: {
      columns
    }
  } = state

  return {
    columns
  }
}

export default connect(mapStateToProps)(DynamicFooter)
